import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import STRING_KEYS from '../../../../language/keys';
import TimeToPayDialog from '../time-to-pay-dialog/time-to-pay-dialog.component';
import { BodyContainer } from '../time-to-pay-dialog/time-to-pay-dialog.styled';
import { TimeToPayDialogActionVariant } from '../time-to-pay-dialog/time-to-pay-dialog.enums';

const UpgradeToEnterpriseDialog = ({
  isOpen,
  onClose,
  actionClickHandler,
  isLoading = false,
  paidPlanRequested,
}: UpgradeToEnterpriseDialogProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const onActionClick = () => {
    if (paidPlanRequested) {
      return;
    }

    actionClickHandler();
  };

  const dialogButtons = useMemo(() => ([{
    title: paidPlanRequested ? translate(STRING_KEYS.UPGRADED_MESSAGE) : translate(STRING_KEYS.UPGRADE_TO_ENTERPRISE_DIALOG.BUTTON_TITLE),
    clickHandler: onActionClick,
    isLoading,
    variant: paidPlanRequested ? TimeToPayDialogActionVariant.Text : TimeToPayDialogActionVariant.Button,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }]), [paidPlanRequested, onActionClick, isLoading, actionClickHandler]);

  return (
    <TimeToPayDialog
      isOpen={ isOpen }
      onClose={ onClose }
      title={ translate(STRING_KEYS.UPGRADE_TO_ENTERPRISE_DIALOG.HEADER_TITLE) }
      buttons={ dialogButtons }
    >
      <BodyContainer>
        <div>{ translate(STRING_KEYS.UPGRADE_TO_ENTERPRISE_DIALOG.HEADER_FIRST_SUB_TITLE) }</div>
        <div>{ translate(STRING_KEYS.UPGRADE_TO_ENTERPRISE_DIALOG.HEADER_SECOND_SUB_TITLE) }</div>
      </BodyContainer>
    </TimeToPayDialog>
  );
};

export default UpgradeToEnterpriseDialog;
